// extracted by mini-css-extract-plugin
export var closed = "_fj-1";
export var resizer = "_fj-0";